<template>
    <el-container>
      <el-header style="height: 128px;">
        <el-row>
          <a href="https://yz.hmc.edu.cn/"><el-image :src="topPic"></el-image></a>
        </el-row>
      </el-header>
      <el-main>
        <el-row>
          <el-tabs type="border-card">

            <el-tab-pane :label="'公共卫生与预防医学（'+this.gwyfTotal+'）'">
              <el-row style="margin: 15px 0 30px 0;">
                <el-col :span="6"></el-col>
                <el-col :span="8" :offset="8">
                  <el-input placeholder="请输入导师姓名" v-model.trim="gwyfSearchText" class="input-with-select" @keyup.enter.native="gwyfHandleFilter()" clearable>
                    <template slot="prepend">公共卫生与预防医学</template>
                    <el-button slot="append" icon="el-icon-search" @click="gwyfHandleFilter()" ></el-button>
                    <div v-for="(item, index) in gwyfSearchMethod" :key="index">{{ item.name }}</div>
                  </el-input>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :xs="12" :sm="6" v-for="data_gwyf in info_gwyf" :key="data_gwyf.id">
                  <div class="grid-content bg-purple">
                    <el-card :body-style="{ padding: '15px 0 15px 0'}" shadow="hover">
                      <el-link :href="data_gwyf.url" target="_blank" type="primary">
                        <el-image :src="data_gwyf.img"></el-image>
                      </el-link>
                      <div>
                        <div class="bottom clearfix">
                          <el-link :href="data_gwyf.url" target="_blank" type="primary">{{ data_gwyf.name }}</el-link>
                        </div>
                        <span ><el-tag class="mt" type="primary" size="small">{{ data_gwyf.title }}</el-tag></span>
                        <div class="mt dir" :title="data_gwyf.direction">{{ data_gwyf.direction }}</div>
                      </div>
                    </el-card>
                  </div>
                </el-col>
              </el-row>
              <div class="block">
                <el-pagination
                  background
                  @size-change="handleSizeChangeGwyf"
                  @current-change="handleCurrentChangeGwyf"
                  :current-page="gwyfPage"
                  :page-sizes="[10, 20, 30, 50, 100]"
                  :page-size="gwyfLimit"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="gwyfTotal"
                  align="center"
                ></el-pagination>
              </div>
            </el-tab-pane>

            <el-tab-pane :label="'基础医学（'+this.jcTotal+'）'">
              <el-row style="margin: 15px 0 30px 0;">
                <el-col :span="6"></el-col>
                <el-col :span="8" :offset="8">
                  <el-input placeholder="请输入导师姓名" v-model.trim="jcSearchText" class="input-with-select" @keyup.enter.native="jcHandleFilter()" clearable>
                    <template slot="prepend">基础医学</template>
                    <el-button slot="append" icon="el-icon-search" @click="jcHandleFilter()" ></el-button>
                    <div v-for="(item, index) in jcSearchMethod" :key="index">{{ item.name }}</div>
                  </el-input>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :xs="12" :sm="6" v-for="data_jc in info_jc" :key="data_jc.id">
                  <div class="grid-content bg-purple">
                    <el-card :body-style="{ padding: '15px 0 15px 0' }" shadow="hover">
                      <el-link :href="data_jc.url" target="_blank" type="primary">
                        <el-image :src="data_jc.img"></el-image>
                      </el-link>
                      <div>
                        <div class="bottom clearfix">
                          <el-link :href="data_jc.url" target="_blank" type="primary">{{ data_jc.name }}</el-link>
                        </div>
                        <span ><el-tag class="mt" type="primary" size="small">{{ data_jc.title }}</el-tag></span>
                        <div class="mt dir" :title="data_jc.direction">{{ data_jc.direction }}</div>
                      </div>
                    </el-card>
                  </div>
                </el-col>
              </el-row>
              <div class="block">
                <el-pagination
                  background
                  @size-change="handleSizeChangeJc"
                  @current-change="handleCurrentChangeJc"
                  :current-page="jcPage"
                  :page-sizes="[10, 20, 30, 50, 100]"
                  :page-size="jcLimit"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="jcTotal"
                  align="center"
                ></el-pagination>
              </div>
            </el-tab-pane>

            <el-tab-pane :label="'药学（'+this.yxTotal+'）'">
              <el-row style="margin: 15px 0 30px 0;">
                <el-col :span="6"></el-col>
                <el-col :span="8" :offset="8">
                  <el-input placeholder="请输入导师姓名" v-model.trim="yxSearchText" class="input-with-select" @keyup.enter.native="yxHandleFilter()" clearable>
                    <template slot="prepend">药学</template>
                    <el-button slot="append" icon="el-icon-search" @click="yxHandleFilter()" ></el-button>
                    <div v-for="(item, index) in yxSearchMethod" :key="index">{{ item.name }}</div>
                  </el-input>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :xs="12" :sm="6" v-for="data_yx in info_yx" :key="data_yx.id">
                  <div class="grid-content bg-purple">
                    <el-card :body-style="{ padding: '15px 0 15px 0' }" shadow="hover">
                      <el-link :href="data_yx.url" target="_blank" type="primary">
                        <el-image :src="data_yx.img"></el-image>
                      </el-link>
                      <div>
                        <div class="bottom clearfix">
                          <el-link :href="data_yx.url" target="_blank" type="primary">{{ data_yx.name }}</el-link>
                        </div>
                        <span ><el-tag class="mt" type="primary" size="small">{{ data_yx.title }}</el-tag></span>
                        <div class="mt dir" :title="data_yx.direction">{{ data_yx.direction }}</div>
                      </div>
                    </el-card>
                  </div>
                </el-col>
              </el-row>
              <div class="block">
                <el-pagination
                  background
                  @size-change="handleSizeChangeYx"
                  @current-change="handleCurrentChangeYx"
                  :current-page="yxPage"
                  :page-sizes="[10, 20, 30, 50, 100]"
                  :page-size="yxLimit"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="yxTotal"
                  align="center"
                ></el-pagination>
              </div>
            </el-tab-pane>

            <el-tab-pane :label="'公共卫生（'+this.gwTotal+'）'">
              <el-row style="margin: 15px 0 30px 0;">
                <el-col :span="6"></el-col>
                <el-col :span="8" :offset="8">
                  <el-input placeholder="请输入导师姓名" v-model.trim="gwSearchText" class="input-with-select" @keyup.enter.native="gwHandleFilter()" clearable>
                    <template slot="prepend">公共卫生</template>
                    <el-button slot="append" icon="el-icon-search" @click="gwHandleFilter()" ></el-button>
                    <div v-for="(item, index) in gwSearchMethod" :key="index">{{ item.name }}</div>
                  </el-input>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :xs="12" :sm="6" v-for="data_gw in info_gw" :key="data_gw.id">
                  <div class="grid-content bg-purple">
                    <el-card :body-style="{ padding: '15px 0 15px 0' }" shadow="hover">
                      <el-link :href="data_gw.url" target="_blank" type="primary">
                       <el-image :src="data_gw.img"></el-image>
                      </el-link>
                      <div>
                        <div class="bottom clearfix">
                          <el-link :href="data_gw.url" target="_blank" type="primary">{{ data_gw.name }}</el-link>
                        </div>
                        <span ><el-tag class="mt" type="primary" size="small">{{ data_gw.title }}</el-tag></span>
                        <div class="mt dir" :title="data_gw.direction">{{ data_gw.direction }}</div>
                      </div>
                    </el-card>
                  </div>
                </el-col>
              </el-row>
              <div class="block">
                <el-pagination
                  background
                  @size-change="handleSizeChangeGw"
                  @current-change="handleCurrentChangeGw"
                  :current-page="gwPage"
                  :page-sizes="[10, 20, 30, 50, 100]"
                  :page-size="gwLimit"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="gwTotal"
                  align="center"
                ></el-pagination>
              </div>
            </el-tab-pane>

            <el-tab-pane :label="'生物与医药（'+this.swyyTotal+'）'">
              <el-row style="margin: 15px 0 30px 0;">
                <el-col :span="6"></el-col>
                <el-col :span="8" :offset="8">
                  <el-input placeholder="请输入导师姓名" v-model.trim="swyySearchText" class="input-with-select" @keyup.enter.native="yxHandleFilter()" clearable>
                    <template slot="prepend">生物与医药</template>
                    <el-button slot="append" icon="el-icon-search" @click="swyyHandleFilter()" ></el-button>
                    <div v-for="(item, index) in swyySearchMethod" :key="index">{{ item.name }}</div>
                  </el-input>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :xs="12" :sm="6" v-for="data_swyy in info_swyy" :key="data_swyy.id">
                  <div class="grid-content bg-purple">
                    <el-card :body-style="{ padding: '15px 0 15px 0' }" shadow="hover">
                      <el-link :href="data_swyy.url" target="_blank" type="primary">
                        <el-image :src="data_swyy.img"></el-image>
                      </el-link>
                      <div>
                        <div class="bottom clearfix">
                          <el-link :href="data_swyy.url" target="_blank" type="primary">{{ data_swyy.name }}</el-link>
                        </div>
                        <span ><el-tag class="mt" type="primary" size="small">{{ data_swyy.title }}</el-tag></span>
                        <div class="mt dir" :title="data_swyy.direction">{{ data_swyy.direction }}</div>
                      </div>
                    </el-card>
                  </div>
                </el-col>
              </el-row>
              <div class="block">
                <el-pagination
                  background
                  @size-change="handleSizeChangeSwyy"
                  @current-change="handleCurrentChangeSwyy"
                  :current-page="swyyPage"
                  :page-sizes="[10, 20, 30, 50, 100]"
                  :page-size="swyyLimit"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="swyyTotal"
                  align="center"
                ></el-pagination>
              </div>
            </el-tab-pane>

            <el-tab-pane :label="'药学（专硕）（'+this.yxzsTotal+'）'">
              <el-row style="margin: 15px 0 30px 0;">
                <el-col :span="6"></el-col>
                <el-col :span="8" :offset="8">
                  <el-input placeholder="请输入导师姓名" v-model.trim="yxzsSearchText" class="input-with-select" @keyup.enter.native="yxzsHandleFilter()" clearable>
                    <template slot="prepend">药学（专硕）</template>
                    <el-button slot="append" icon="el-icon-search" @click="yxzsHandleFilter()" ></el-button>
                    <div v-for="(item, index) in yxzsSearchMethod" :key="index">{{ item.name }}</div>
                  </el-input>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :xs="12" :sm="6" v-for="data_yxzs in info_yxzs" :key="data_yxzs.id">
                  <div class="grid-content bg-purple">
                    <el-card :body-style="{ padding: '15px 0 15px 0' }" shadow="hover">
                      <el-link :href="data_yxzs.url" target="_blank" type="primary">
                        <el-image :src="data_yxzs.img"></el-image>
                      </el-link>
                      <div>
                        <div class="bottom clearfix">
                          <el-link :href="data_yxzs.url" target="_blank" type="primary">{{ data_yxzs.name }}</el-link>
                        </div>
                        <span ><el-tag class="mt" type="primary" size="small">{{ data_yxzs.title }}</el-tag></span>
                        <div class="mt dir" :title="data_yxzs.direction">{{ data_yxzs.direction }}</div>
                      </div>
                    </el-card>
                  </div>
                </el-col>
              </el-row>
              <div class="block">
                <el-pagination
                  background
                  @size-change="handleSizeChangeYxzs"
                  @current-change="handleCurrentChangeYxzs"
                  :current-page="yxzsPage"
                  :page-sizes="[10, 20, 30, 50, 100]"
                  :page-size="yxzsLimit"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="yxzsTotal"
                  align="center"
                ></el-pagination>
              </div>
            </el-tab-pane>

            <el-tab-pane :label="'专项导师（'+this.zxdsTotal+'）'">
              <el-row style="margin: 15px 0 30px 0;">
                <el-col :span="6"></el-col>
                <el-col :span="8" :offset="8">
                  <el-input placeholder="请输入导师姓名" v-model.trim="zxdsSearchText" class="input-with-select" @keyup.enter.native="yxHandleFilter()" clearable>
                    <template slot="prepend">专项导师</template>
                    <el-button slot="append" icon="el-icon-search" @click="zxdsHandleFilter()" ></el-button>
                    <div v-for="(item, index) in zxdsSearchMethod" :key="index">{{ item.name }}</div>
                  </el-input>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :xs="12" :sm="6" v-for="data_zxds in info_zxds" :key="data_zxds.id">
                  <div class="grid-content bg-purple">
                    <el-card :body-style="{ padding: '15px 0 15px 0' }" shadow="hover">
                      <el-link :href="data_zxds.url" target="_blank" type="primary">
                        <el-image :src="data_zxds.img"></el-image>
                      </el-link>
                      <div>
                        <div class="bottom clearfix">
                          <el-link :href="data_zxds.url" target="_blank" type="primary">{{ data_zxds.name }}</el-link>
                        </div>
                        <span ><el-tag class="mt" type="primary" size="small">{{ data_zxds.title }}</el-tag></span>
                        <div class="mt dir" :title="data_zxds.direction">{{ data_zxds.direction }}</div>
                      </div>
                    </el-card>
                  </div>
                </el-col>
              </el-row>
              <div class="block">
                <el-pagination
                  background
                  @size-change="handleSizeChangeZxds"
                  @current-change="handleCurrentChangeZxds"
                  :current-page="zxdsPage"
                  :page-sizes="[10, 20, 30, 50, 100]"
                  :page-size="zxdsLimit"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="zxdsTotal"
                  align="center"
                ></el-pagination>
              </div>
            </el-tab-pane>

          </el-tabs>
        </el-row>
      </el-main>
    </el-container>

  <!-- <div class="block">
    <el-carousel :interval="3000" type="card" height="98px">
      <el-carousel-item v-for="item in imgList" :key="item.name">
        <img :src="item.src" style="width:100%;" alt="图片" :title="item.title" />
      </el-carousel-item>
    </el-carousel>
  </div> -->

</template>

<script>
// https://echarts.apache.org/zh/spreadsheet.html 网站生成JSON数据（注意有数据量限制，<110条）
import picUrl from '../assets/top.png'
import jsonGwyfData from '../../static/data_gwyf.json'
import jsonYxData from '../../static/data_yx.json'
import jsonJcData from '../../static/data_jc.json'
import jsonGwData from '../../static/data_gw.json'
import jsonYxzsData from '../../static/data_yxzs.json'
import jsonSwyyData from '../../static/data_swyy.json'
import jsonZxdsData from '../../static/data_zxds.json'

export default {
  name: 'Tutor',
  data () {
    return {
      visible: false,
      topPic: picUrl,
      // 公共卫生与预防医学
      info_gwyf: [],
      gwyfSearchText: '',
      gwyfPage: 1,
      gwyfLimit: 20,
      gwyfTotal: 0,
      // 药学
      info_yx: [],
      yxSearchText: '',
      yxPage: 1,
      yxLimit: 20,
      yxTotal: 0,
      // 基础医学
      info_jc: [],
      jcSearchText: '',
      jcPage: 1,
      jcLimit: 20,
      jcTotal: 0,
      // 公共卫生
      info_gw: [],
      gwSearchText: '',
      gwPage: 1,
      gwLimit: 20,
      gwTotal: 0,
      // 药学（专硕）
      info_yxzs: [],
      yxzsSearchText: '',
      yxzsPage: 1,
      yxzsLimit: 20,
      yxzsTotal: 0,
      // 生物与医药
      info_swyy: [],
      swyySearchText: '',
      swyyPage: 1,
      swyyLimit: 20,
      swyyTotal: 0,
      // 专项导师
      info_zxds: [],
      zxdsSearchText: '',
      zxdsPage: 1,
      zxdsLimit: 20,
      zxdsTotal: 0
    }
  },
  computed: {
    // 公共卫生与预防医学
    gwyfSearchMethod () {
      return jsonGwyfData.data.filter(value => {
        return value.name.match(this.gwyfSearchText)
      })
    },
    // 药学
    yxSearchMethod () {
      return jsonYxData.data.filter(value => {
        return value.name.match(this.yxSearchText)
      })
    },
    // 基础医学
    jcSearchMethod () {
      return jsonJcData.data.filter(value => {
        return value.name.match(this.jcSearchText)
      })
    },
    // 公共卫生
    gwSearchMethod () {
      return jsonGwData.data.filter(value => {
        return value.name.match(this.gwSearchText)
      })
    },
    // 药学（专硕）
    yxzsSearchMethod () {
      return jsonYxzsData.data.filter(value => {
        return value.name.match(this.yxzsSearchText)
      })
    },
    // 生物与医药
    swyySearchMethod () {
      return jsonSwyyData.data.filter(value => {
        return value.name.match(this.swyySearchText)
      })
    },
    // 专项导师
    zxdsSearchMethod () {
      return jsonZxdsData.data.filter(value => {
        return value.name.match(this.zxdsSearchText)
      })
    }
  },
  mounted () {
    // 加载公共卫生与预防医学数据
    this.info_gwyf = jsonGwyfData.data.slice((this.gwyfPage - 1) * this.gwyfLimit, this.gwyfPage * this.gwyfLimit)
    this.gwyfTotal = jsonGwyfData.total

    // 加载药学数据
    this.info_yx = jsonYxData.data.slice((this.yxPage - 1) * this.yxLimit, this.yxPage * this.yxLimit)
    this.yxTotal = jsonYxData.total

    // 加载基础医学数据
    this.info_jc = jsonJcData.data.slice((this.jcPage - 1) * this.jcLimit, this.jcPage * this.jcLimit)
    this.jcTotal = jsonJcData.total

    // 加载公共卫生数据
    this.info_gw = jsonGwData.data.slice((this.gwPage - 1) * this.gwLimit, this.gwPage * this.gwLimit)
    this.gwTotal = jsonGwData.total

    // 加载药学（专硕）数据
    this.info_yxzs = jsonYxzsData.data.slice((this.yxzsPage - 1) * this.yxzsLimit, this.yxzsPage * this.yxzsLimit)
    this.yxzsTotal = jsonYxzsData.total

    // 加载生物与医药数据
    this.info_swyy = jsonSwyyData.data.slice((this.swyyPage - 1) * this.swyyLimit, this.swyyPage * this.swyyLimit)
    this.swyyTotal = jsonSwyyData.total

    // 加载专项导师数据
    this.info_zxds = jsonZxdsData.data.slice((this.zxdsPage - 1) * this.zxdsLimit, this.zxdsPage * this.zxdsLimit)
    this.zxdsTotal = jsonZxdsData.total
  },
  methods: {

    // 公共卫生与预防医学
    getGwyfData () {
      this.info_gwyf = jsonGwyfData.data.slice((this.gwyfPage - 1) * this.gwyfLimit, this.gwyfPage * this.gwyfLimit)
    },
    gwyfHandleFilter () {
      if (this.gwyfSearchText === '') {
        this.getGwyfData()
        return false
      }
      this.info_gwyf = this.gwyfSearchMethod
    },
    handleSizeChangeGwyf (val) {
      this.gwyfLimit = val
      this.getGwyfData()
    },
    handleCurrentChangeGwyf (val) {
      this.gwyfPage = val
      this.getGwyfData()
    },

    // 药学
    getYxData () {
      this.info_yx = jsonYxData.data.slice((this.yxPage - 1) * this.yxLimit, this.yxPage * this.yxLimit)
    },
    yxHandleFilter () {
      if (this.yxSearchText === '') {
        this.getYxData()
        return false
      }
      this.info_yx = this.yxSearchMethod
    },
    handleSizeChangeYx (val) {
      this.yxLimit = val
      this.getYxData()
    },
    handleCurrentChangeYx (val) {
      this.yxPage = val
      this.getYxData()
    },

    // 基础医学
    getJcData () {
      this.info_jc = jsonJcData.data.slice((this.jcPage - 1) * this.jcLimit, this.jcPage * this.jcLimit)
    },
    jcHandleFilter () {
      if (this.jcSearchText === '') {
        this.getJcData()
        return false
      }
      this.info_jc = this.jcSearchMethod
    },
    handleSizeChangeJc (val) {
      this.jcLimit = val
      this.getJcData()
    },
    handleCurrentChangeJc (val) {
      this.jcPage = val
      this.getJcData()
    },

    // 公共卫生
    getGwData () {
      this.info_gw = jsonGwData.data.slice((this.gwPage - 1) * this.gwLimit, this.gwPage * this.gwLimit)
    },
    gwHandleFilter () {
      if (this.gwSearchText === '') {
        this.getGwData()
        return false
      }
      this.info_gw = this.gwSearchMethod
    },
    handleSizeChangeGw (val) {
      this.gwLimit = val
      this.getGwData()
    },
    handleCurrentChangeGw (val) {
      this.gwPage = val
      this.getGwData()
    },

    // 药学(专硕)
    getYxzsData () {
      this.info_yxzs = jsonYxzsData.data.slice((this.yxzsPage - 1) * this.yxzsLimit, this.yxzsPage * this.yxzsLimit)
    },
    yxzsHandleFilter () {
      if (this.yxzsSearchText === '') {
        this.getYxzsData()
        return false
      }
      this.info_yxzs = this.yxzsSearchMethod
    },
    handleSizeChangeYxzs (val) {
      this.yxzsLimit = val
      this.getYxzsData()
    },
    handleCurrentChangeYxzs (val) {
      this.yxzsPage = val
      this.getYxzsData()
    },

    // 生物与医药
    getSwyyData () {
      this.info_swyy = jsonSwyyData.data.slice((this.swyyPage - 1) * this.swyyLimit, this.swyyPage * this.swyyLimit)
    },
    swyyHandleFilter () {
      if (this.swyySearchText === '') {
        this.getSwyyData()
        return false
      }
      this.info_swyy = this.swyySearchMethod
    },
    handleSizeChangeSwyy (val) {
      this.swyyLimit = val
      this.getSwyyData()
    },
    handleCurrentChangeSwyy (val) {
      this.swyyPage = val
      this.getSwyyData()
    },

    // 专项导师
    getZxdsData () {
      this.info_zxds = jsonZxdsData.data.slice((this.zxdsPage - 1) * this.zxdsLimit, this.zxdsPage * this.zxdsLimit)
    },
    zxdsHandleFilter () {
      if (this.zxdsSearchText === '') {
        this.getzxdsData()
        return false
      }
      this.info_zxds = this.zxdsSearchMethod
    },
    handleSizeChangeZxds (val) {
      this.zxdsLimit = val
      this.getZxdsData()
    },
    handleCurrentChangeZxds (val) {
      this.zxdsPage = val
      this.getZxdsData()
    }
  }
}

</script>

<style scoped>
    .el-header {
      background-color: #2A63BC;
      height: 128px;
      line-height: 128px;
    }

    .el-header span{
      color: #fff;
      font-size: 30px;
    }

    .el-card {
      margin-bottom: 20px;
      text-align: center;
    }

    .el-card .el-image {
      width: 120px;
      height: 168px;
      margin-top: 8px;
    }

    .mt {
      margin-top: 8px;
    }

    .dir {
      padding: 0 10px 0 10px;
      font-size: 13px;
      color: #666666;
      overflow:hidden;
      text-Overflow:ellipsis;
      white-Space:nowrap;
    }

</style>



// WEBPACK FOOTER //
// src/components/Tutor.vue